import axios from '../axios'
import { getParameterByName } from './../../utils/util'

const uploadImg = (uploadUrl, formData) => {
  return axios({
    url: uploadUrl,
    method: 'post',
    data: formData,
    headers:{'Content-Type':'multipart/form-data'},
  })
}

// 上传图片识别条形码
const scanUploadImg = (formData) => {
  return axios.post('https://py-version.danghuan.com/imei', formData, {
    headers:{'Content-Type':'application/json'},
  })
}

// 获取 OSS POST 上传授权（params 需含 contentType；token 从 URL 自动带上）
const policyPutUpload = (params = {}) => {
  return axios({
    url: '/file/policyPostUpload',
    method: 'get',
    params: {
      ...params,
      token: getParameterByName('token')
    }
  })
}
export {
  uploadImg,
  scanUploadImg,
  policyPutUpload
}
